import axios from "axios";
import { getAuthHeaders } from "../auth/util";
import {
  Bet,
  BetCreation,
  Wager,
  WagerCreation,
  WagerResolution,
} from "./types";

const uri = process.env.REACT_APP_WANNABET_API;

export async function getWagers(query: string) {
  var wagers = (
    await axios.get<Wager[]>(`${uri}/wagers?` + query, {
      headers: { "Content-Type": "application/json" },
    })
  ).data;
  return wagers;
}

export async function getWager(id: string) {
  var wager = (await axios.get<Wager>(`${uri}/wagers/${id}`)).data;
  return wager;
}

export async function createWager(wager: WagerCreation) {
  return (
    await axios.post<Wager>(`${uri}/wagers`, wager, {
      headers: getAuthHeaders(),
    })
  ).data;
}

export async function resolveWager(wagerResolution: WagerResolution) {
  return (
    await axios.put<Wager>(
      `${uri}/wagers/${wagerResolution.wagerId}/outcome`,
      wagerResolution,
      {
        headers: getAuthHeaders(),
      }
    )
  ).data;
}

export async function getBets(query: string) {
  var bets = (await axios.get<Bet[]>(`${uri}/bets?` + query)).data;
  return bets;
}

export async function getBet(id: string) {
  var bet = (await axios.get<Bet>(`${uri}/bets/${id}`)).data;
  return bet;
}

export async function createBet(bet: BetCreation) {
  return (
    await axios.post<Bet>(`${uri}/bets`, bet, {
      headers: getAuthHeaders(),
    })
  ).data;
}
